import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20modern%20minimalist%20technology%20concept%20scene%20with%20abstract%20flowing%20geometric%20shapes%20in%20warm%20golden%20and%20cream%20tones%2C%20soft%20gradient%20background%20with%20subtle%20texture%2C%20clean%20and%20elegant%20atmosphere%2C%20professional%20corporate%20style%2C%20no%20text%2C%20abstract%20digital%20art&width=1920&height=900&seq=mjhl-hero-bg&orientation=landscape"
        alt="MJHL 品牌背景"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight tracking-tight">
            MJHL
            <span className="block mt-2 text-xl md:text-3xl lg:text-4xl font-medium text-white/90">
              值得信赖的首选品牌
            </span>
          </h1>
          <p className="mt-6 md:mt-8 text-base md:text-lg text-white/80 max-w-2xl mx-auto leading-relaxed">
            以科技创新驱动美好生活，MJHL 为全球用户提供智能家居、企业服务、健康科技、教育科技等全方位的卓越产品与服务体验，助力每个人拥抱更智慧、更便捷的未来。
          </p>
          <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/categories"
              className="px-8 py-3 bg-primary-500 text-white font-medium rounded-md hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap text-sm"
            >
              探索产品服务
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 border border-white/60 text-white font-medium rounded-md hover:bg-white/10 transition-all duration-200 cursor-pointer whitespace-nowrap text-sm"
            >
              了解 MJHL
            </Link>
          </div>
          <div className="mt-10 md:mt-14 flex items-center justify-center gap-8 md:gap-16 text-white/70">
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-white">50万+</div>
              <div className="text-xs md:text-sm mt-1">家庭用户信赖</div>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-white">1000+</div>
              <div className="text-xs md:text-sm mt-1">企业客户选择</div>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-white">98%</div>
              <div className="text-xs md:text-sm mt-1">用户好评率</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}